import { Button, TextField } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React, { useState } from "react";
import * as tenantApi from "../../../api/tenantApi";
import { useI18n } from "../../../hooks/useI18n";
import useStyles from "../styles";

interface Support {
  helpId?: string;
  faqId?: string;
  legalId?: string;
}

export interface SupportEditorProps {
  tenantId: string;
  support: Support;
  onSave: () => void;
}

export const SupportEditor: React.FunctionComponent<SupportEditorProps> = ({
  tenantId,
  support,
  onSave
}) => {
  const classes = useStyles();
  const { t } = useI18n();

  const [state, setState] = useState<any>({
    editingSupport: support ?? ({} as Support)
  });

  return (
    <>
      <TextField
        className={classes.field}
        label={t("common.formFields.helpId")}
        value={state.editingSupport?.helpId}
        onChange={e =>
          setState({
            ...state,
            editingSupport: {
              ...state.editingSupport,
              helpId: e.target.value
            }
          })
        }
      />
      <TextField
        className={classes.field}
        label={t("common.formFields.faqId")}
        required
        value={state.editingSupport?.faqId}
        onChange={e =>
          setState({
            ...state,
            editingSupport: {
              ...state.editingSupport,
              faqId: e.target.value
            }
          })
        }
      />
      <TextField
        className={classes.field}
        label={t("common.formFields.legalId")}
        required
        value={state.editingSupport?.legalId}
        onChange={e =>
          setState({
            ...state,
            editingSupport: {
              ...state.editingSupport,
              legalId: e.target.value
            }
          })
        }
      />
      <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
        <Button
          style={{ width: 200 }}
          variant="contained"
          color="primary"
          onClick={async () => {
            const result = await tenantApi.upsertSupport(
              tenantId,
              state.editingSupport
            );

            if (result.type !== "OK") {
              setState({ ...state, editOrUpdateSupportFailed: true });
            } else {
              onSave();
            }
          }}
        >
          {t("common.actions.saveSupport")}
        </Button>
        {state.editOrUpdateSupportFailed && (
          <Alert severity="error">{t("common.messages.supportError")}</Alert>
        )}
      </div>
    </>
  );
};
